// App.tsx
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";

import Intro from "./Intropage/Intro.tsx";
import About from "./components/About/About";
import Header from "./components/pageheader";
import Footer from "./components/footer.tsx";
import Hackathon from "./components/Hackathon/Index";
import { ContactUs } from "./components/Contact/Contact";
import EventPage from "./components/EventPage/EventPage.tsx";
import WatchClock from "./components/Clock/WatchClock.tsx";
import SponsorsPage from "./components/Sponsors/index.tsx";
import Index from "./components/Members/Index";
import { CircuitTimeline } from "./components/CircuitTimeline/CircuitTimeline.tsx";
import EventDetail from "./components/EventSolo/index";
import PassesPage from "./components/Passes";
function App() {
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    const path = window.location.pathname;
    if (path !== "/") {
      setShowIntro(false);
    }
  }, []);

  const handleIntroComplete = () => {
    setShowIntro(false);
  };

  return (
    <Router>
      <div className="App">
        <Header />

        <main className="flex-grow">
          <Routes>
            <Route
              path="/"
              element={
                showIntro ? (
                  <Intro onComplete={handleIntroComplete} />
                ) : (
                  <EventPage />
                )
              }
            />
            <Route path="/events" element={<EventPage />} />
            <Route path="/event/:eventId" element={<EventDetail />} /> {/* Add this route */}
            <Route path="/CircuitTimeline" element={<CircuitTimeline />} />
            <Route path="/clock" element={<WatchClock />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/sponsors" element={<SponsorsPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/members" element={<Index />} />
            <Route path="/hackathon" element={<Hackathon />} />
                        <Route path="/passes" element={<PassesPage />} />


            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;